import { apiClient } from './api.js';
import { unwrap } from './api-error.js';
import type { ApiPaths } from '@reos/api-client';

/**
 * Klient fronty upozorneni maklere (krok NOTIF1): „Novinky" na Dnesku
 * a pocitadlo v menu.
 *
 * POZOR NA JMENO: `lib/notifications.ts` je neco JINEHO — push notifikace
 * prohlizece (Service Worker). Tohle je serverova fronta „co se stalo
 * v kancelari a jeste jsi to necetl".
 *
 * Upozorneni ze serveru nese DRUH a POPISEK PREDMETU, ne hotovou vetu —
 * tu sklada UI z katalogu `@reos/i18n` (`crm.notification.kind.*`), takze
 * cestina a anglictina maji paritu.
 */

type Json = 'application/json';

export type BrokerNotificationList = NonNullable<
  ApiPaths['/v1/crm/notifications']['get']['responses']['200']['content'][Json]
>;
export type BrokerNotification = BrokerNotificationList['items'][number];
export type BrokerNotificationKind = BrokerNotification['kind'];

export const UNREAD_NOTIFICATIONS_QUERY_KEY = ['crm-notifications', 'unread'] as const;

/** Nepreectena upozorneni prihlaseneho maklere (nejnovejsi prvni). */
export async function listUnreadNotifications(limit = 20): Promise<BrokerNotificationList> {
  return unwrap(apiClient.GET('/v1/crm/notifications', { params: { query: { unread: true, limit } } }));
}

/** Prazdne `ids` = oznac prectena VSECHNA nepreectena. */
export async function markNotificationsRead(ids: readonly string[] = []): Promise<void> {
  await unwrap(apiClient.POST('/v1/crm/notifications/read', { body: { ids: [...ids] } }));
}

/*
 * Krok NAP6 A14 — NASTAVENI UPOZORNENI KANCELARE. API je hotove od NOTIF1,
 * obrazovka chybela; klient zije tady, u fronty upozorneni, aby nebyly dva
 * soubory o tomtez (`notification-settings` vs `notifications`).
 */

export type NotificationSettings = NonNullable<
  ApiPaths['/v1/crm/notification-settings']['get']['responses']['200']['content'][Json]
>;

export type NotificationSettingsPatch = NonNullable<
  ApiPaths['/v1/crm/notification-settings']['patch']['requestBody']
>['content'][Json];

export const NOTIFICATION_SETTINGS_QUERY_KEY = ['nastaveni', 'crm-notification-settings'] as const;

export async function getNotificationSettings(): Promise<NotificationSettings> {
  return unwrap(apiClient.GET('/v1/crm/notification-settings', {}));
}

export async function saveNotificationSettings(patch: NotificationSettingsPatch): Promise<NotificationSettings> {
  return unwrap(apiClient.PATCH('/v1/crm/notification-settings', { body: patch }));
}
